export default {
  path: '/storage',
  name: 'storage',
  component: () => import('@/views/storage/Index'),
  redirect: { name: 'storage-product-storage-orders' },
  children: [
    {
      path: 'product-storage',
      component: () => import('@/views/storage/product-storage/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/storage/product-storage/Layout'),
          children: [
            {
              path: 'orders',
              name: 'storage-product-storage-orders',
              component: () => import('@/views/storage/product-storage/orders/List'),
              meta: {
                title: 'Storage',
                roles: ['general_manager']
              },
            },
            {
              path: 'transfers',
              name: 'storage-product-storage-transfers',
              component: () => import('@/views/storage/product-storage/Transfers'),
              meta: {
                title: 'Storage',
                roles: ['general_manager']
              },
            },
            {
              path: 'stock',
              name: 'storage-product-storage-stock',
              component: () => import('@/views/storage/product-storage/Stock'),
              meta: {
                title: 'Storage',
                roles: ['general_manager']
              },
            },
          ],
        },
        {
          path: 'orders/:id',
          name: 'storage-product-storage-orders-detail',
          component: () => import('@/views/storage/product-storage/orders/Detail'),
          meta: {
            title: 'Storage',
            roles: ['general_manager']
          },
        },
      ]
    },
    {
      path: 'climbing-equipment',
      name: 'storage-climbing-equipment',
      component: () => import('@/views/storage/ClimbingEquipment'),
      meta: {
        title: 'Storage',
        roles: ['general_manager']
      },
    },
    {
      path: 'kitchen-equipment',
      name: 'storage-kitchen-equipment',
      component: () => import('@/views/storage/KitchenEquipment'),
      meta: {
        title: 'Storage',
        roles: ['general_manager']
      },
    },
    {
      path: 'climbing-electronics',
      name: 'storage-climbing-electronics',
      component: () => import('@/views/storage/ClimbingElectronics'),
      meta: {
        title: 'Storage',
        roles: ['general_manager']
      },
    },
    {
      path: 'medications-equipment',
      name: 'storage-medications-equipment',
      component: () => import('@/views/storage/MedicationEquipment'),
      meta: {
        title: 'Storage',
        roles: ['general_manager']
      },
    },
    {
      path: 'oxygen-gas',
      name: 'storage-oxygen-gas',
      component: () => import('@/views/storage/OxygenGas'),
      meta: {
        title: 'Storage',
        roles: ['general_manager']
      },
    },
    {
      path: 'supplier-prices',
      component: () => import('@/views/storage/supplier-prices/Index'),
      children: [
        {
          path: '',
          name: 'storage-supplier-prices',
          component: () => import('@/views/storage/supplier-prices/List'),
          meta: {
            title: 'Storage',
            roles: ['general_manager']
          },
        },
        {
          path: ':id',
          component: () => import('@/views/storage/supplier-prices/detail/Layout'),
          children: [
            {
              path: '',
              name: 'storage-supplier-prices-detail',
              component: () => import('@/views/storage/supplier-prices/detail/Items'),
              meta: {
                title: 'Storage',
                roles: ['general_manager']
              },
            }
          ]
        },
      ]
    },
    {
      path: 'items',
      component: () => import('@/views/storage/items/Index'),
      children: [
        {
          path: '',
          name: 'storage-items',
          component: () => import('@/views/storage/items/List'),
          meta: {
            title: 'Storage',
            roles: ['general_manager']
          },
        },
        {
          path: ':id',
          name: 'storage-items-detail',
          component: () => import('@/views/storage/items/Detail'),
          meta: {
            title: 'Storage',
            roles: ['general_manager']
          },
        },
      ]
    },
  ],
}